export type Lang = 'ru' | 'en';

const en = {
  // Common
  'common.loading': 'Loading…',
  'common.back': 'Back',
  'common.cancel': 'Cancel',
  'common.save': 'Save',
  'common.copy': 'Copy',
  'common.copied': 'Copied',
  'common.send': 'Send',
  'common.sending': 'Sending…',
  'common.sent': 'Sent',
  'common.share': 'Share',
  'common.download': 'Download',
  'common.created': 'Created',
  'common.signed': 'Signed',
  'common.pending': 'Pending',
  'common.all': 'All',
  'common.role': 'Role',
  'common.status': 'Status',
  'common.sort': 'Sort',
  'common.search': 'Search',
  'common.optional': 'optional',
  'common.next': 'Next',
  'common.error': 'Something went wrong',

  // Landing
  'landing.title': 'ReleaseSnap',
  'landing.subtitle.helen': 'Photographer? Open the ReleaseSnap Telegram bot to create or manage releases.',
  'landing.subtitle.model': 'Recipients: open the signing link you received by email or Telegram.',

  // Admin shell
  'admin.tabs.create': 'New Release',
  'admin.tabs.history': 'History',
  'admin.openInTelegram.title': 'Open in Telegram',
  'admin.openInTelegram.body': 'This is the admin Mini App. Open it from the ReleaseSnap Telegram bot to continue.',

  // Roles
  'role.model': 'Model',
  'role.makeup_artist': 'Makeup Artist',
  'role.makeup_artist.short': 'MUA',
  'role.stylist': 'Stylist',
  'role.retoucher': 'Retoucher',
  'role.assistant': 'Assistant',
  'role.other': 'Other',
  'role.contributor': 'Contributor',

  // Create release form
  'create.heading': 'New Release',
  'create.section.photographer': 'Photographer',
  'create.section.shoot': 'Shoot',
  'create.section.role': 'Recipient Role',
  'create.field.name': 'Full Name',
  'create.field.company': 'Company',
  'create.field.email': 'Email (signed PDF goes here)',
  'create.field.title': 'Project Title',
  'create.field.date': 'Date',
  'create.field.location': 'Location',
  'create.field.description': 'Description',
  'create.field.commercial': 'Allow Commercial Use',
  'create.aiImprove': 'Improve with AI',
  'create.aiImproving': 'Improving…',
  'create.submit': 'Generate Signing Link',
  'create.submitting': 'Creating…',
  'create.linkReady': 'Link Ready',
  'create.copy': 'Copy',
  'create.sendToTelegram': 'Send to my Telegram',
  'create.sentToTelegram': 'Sent to chat',
  'create.another': 'Create another',
  'create.tip': 'Tap "Send to my Telegram" to receive the link in the bot chat — easy to forward.',
  'create.placeholder.name': 'Helen Bloom',
  'create.placeholder.email': 'you@example.com',
  'create.placeholder.title': 'Summer Lookbook 2026',
  'create.placeholder.location': 'New York',
  'create.placeholder.description': 'Outdoor fashion photography…',
  'create.error.requiredFields': 'Please fill in Photographer Name, Email and Shoot Title',
  'create.error.generic': 'Failed to create link',

  // History
  'history.search.placeholder': 'Search by project name…',
  'history.exportCsv': 'CSV',
  'history.group': 'Group',
  'history.empty': 'No releases match these filters.',
  'history.loading': 'Loading releases…',
  'history.sort.created_at': 'Created',
  'history.sort.signed_at': 'Signed',
  'history.sort.shoot_title': 'Project',
  'history.sort.role': 'Role',
  'history.sortDirection.asc': 'oldest first',
  'history.sortDirection.desc': 'newest first',

  // Detail
  'detail.backToHistory': 'Back to history',
  'detail.signer': 'Signer',
  'detail.field.name': 'Name',
  'detail.field.email': 'Email',
  'detail.field.phone': 'Phone',
  'detail.field.dob': 'Date of birth',
  'detail.field.address': 'Address',
  'detail.section.shareLink': 'Share signing link',
  'detail.section.signedPdf': 'Signed PDF',
  'detail.section.sendByEmail': 'Send PDF by email',
  'detail.action.toMyChat': 'To my chat',
  'detail.action.toMyChatSent': 'Sent',
  'detail.action.downloadPdf': 'Download PDF',
  'detail.action.shareTelegram': 'Share via Telegram',
  'detail.action.sendEmail': 'Send',
  'detail.email.placeholder': 'recipient@example.com',
  'detail.email.success': 'Sent to',
  'detail.email.failed': 'Failed to send to',
  'detail.notFound': 'Release not found',

  // Status badges
  'status.signed': 'Signed',
  'status.pending': 'Pending',

  // Sign form (recipient)
  'sign.role.banner': 'YOU ARE SIGNING AS',
  'sign.step.info': 'Your info',
  'sign.step.review': 'Review & Sign',
  'sign.step.done': 'Done',
  'sign.intro.model': 'Please fill in your details to create the Model Release.',
  'sign.intro.contributor': 'Please fill in your details to create the Contributor Release.',
  'sign.field.fullName': 'Full Legal Name',
  'sign.field.dob': 'Date of Birth',
  'sign.field.phone': 'Phone',
  'sign.field.email': 'Email',
  'sign.field.address': 'Current Address',
  'sign.placeholder.fullName': 'Jane Doe',
  'sign.placeholder.phone': '+1 (555) …',
  'sign.placeholder.email': 'jane@example.com',
  'sign.placeholder.address': 'Street, City, State, Zip',
  'sign.next': 'Continue',
  'sign.summary.title': 'Summary of Terms',
  'sign.summary.fullText': 'Full text is on the next page. By signing you confirm all of the following:',
  'sign.signHere': 'Sign Here',
  'sign.signHere.hint': 'Use your finger or mouse to sign above.',
  'sign.clear': 'Clear signature',
  'sign.agreement': 'I have read the terms and provide my full consent.',
  'sign.complete': 'Sign & Complete',
  'sign.signing': 'Submitting…',
  'sign.overlay.title': 'Submitting your release…',
  'sign.overlay.body': "Please don't close this tab. We're creating the PDF and sending it to the photographer.",
  'sign.overlay.timing': 'This usually takes 5–10 seconds.',
  'sign.success.title': 'Release Signed',
  'sign.success.toPhotographer': 'Sent to photographer',
  'sign.success.saved': 'Saved on the server',
  'sign.success.error': 'Submission error',
  'sign.success.sending': 'Sending to photographer…',
  'sign.downloadPdf': 'Download PDF',
  'sign.alreadySigned': 'This release has already been signed.',
  'sign.linkNotFound.title': 'Link not found',
  'sign.linkNotFound.body': 'This signing link is invalid or has expired. Ask the photographer for a new one.',
  'sign.lang.switch': 'Language',

  // Date helpers
  'date.today': 'today',
  'date.yesterday': 'yesterday',
  'date.daysAgo': '{n}d ago',
} as const;

const ru: Record<keyof typeof en, string> = {
  // Common
  'common.loading': 'Загрузка…',
  'common.back': 'Назад',
  'common.cancel': 'Отмена',
  'common.save': 'Сохранить',
  'common.copy': 'Копировать',
  'common.copied': 'Скопировано',
  'common.send': 'Отправить',
  'common.sending': 'Отправка…',
  'common.sent': 'Отправлено',
  'common.share': 'Поделиться',
  'common.download': 'Скачать',
  'common.created': 'Создано',
  'common.signed': 'Подписано',
  'common.pending': 'Ожидает',
  'common.all': 'Все',
  'common.role': 'Роль',
  'common.status': 'Статус',
  'common.sort': 'Сортировка',
  'common.search': 'Поиск',
  'common.optional': 'необязательно',
  'common.next': 'Далее',
  'common.error': 'Что-то пошло не так',

  // Landing
  'landing.title': 'ReleaseSnap',
  'landing.subtitle.helen': 'Фотограф? Откройте Telegram-бот ReleaseSnap, чтобы создавать и управлять релизами.',
  'landing.subtitle.model': 'Получатели: откройте ссылку для подписания, которую вам прислали.',

  // Admin shell
  'admin.tabs.create': 'Новый релиз',
  'admin.tabs.history': 'История',
  'admin.openInTelegram.title': 'Откройте в Telegram',
  'admin.openInTelegram.body': 'Это административная Mini App. Откройте её через Telegram-бот ReleaseSnap.',

  // Roles
  'role.model': 'Модель',
  'role.makeup_artist': 'Визажист',
  'role.makeup_artist.short': 'Визаж',
  'role.stylist': 'Стилист',
  'role.retoucher': 'Ретушёр',
  'role.assistant': 'Ассистент',
  'role.other': 'Другое',
  'role.contributor': 'Участник',

  // Create release form
  'create.heading': 'Новый релиз',
  'create.section.photographer': 'Фотограф',
  'create.section.shoot': 'Съёмка',
  'create.section.role': 'Роль получателя',
  'create.field.name': 'Полное имя',
  'create.field.company': 'Компания',
  'create.field.email': 'Email (туда придёт подписанный PDF)',
  'create.field.title': 'Название проекта',
  'create.field.date': 'Дата',
  'create.field.location': 'Локация',
  'create.field.description': 'Описание',
  'create.field.commercial': 'Разрешить коммерческое использование',
  'create.aiImprove': 'Улучшить с AI',
  'create.aiImproving': 'Улучшаю…',
  'create.submit': 'Создать ссылку',
  'create.submitting': 'Создаю…',
  'create.linkReady': 'Ссылка готова',
  'create.copy': 'Копировать',
  'create.sendToTelegram': 'Отправить мне в Telegram',
  'create.sentToTelegram': 'Отправлено в чат',
  'create.another': 'Создать ещё',
  'create.tip': 'Нажмите «Отправить мне в Telegram», чтобы получить ссылку в чат с ботом — её удобно переслать модели.',
  'create.placeholder.name': 'Helen Bloom',
  'create.placeholder.email': 'helen@example.com',
  'create.placeholder.title': 'Summer Lookbook 2026',
  'create.placeholder.location': 'New York',
  'create.placeholder.description': 'Outdoor fashion photography…',
  'create.error.requiredFields': 'Заполните имя фотографа, email и название проекта',
  'create.error.generic': 'Не удалось создать ссылку',

  // History
  'history.search.placeholder': 'Поиск по названию проекта…',
  'history.exportCsv': 'CSV',
  'history.group': 'Группа',
  'history.empty': 'Нет релизов под эти фильтры.',
  'history.loading': 'Загружаю релизы…',
  'history.sort.created_at': 'Дата создания',
  'history.sort.signed_at': 'Дата подписи',
  'history.sort.shoot_title': 'Проект',
  'history.sort.role': 'Роль',
  'history.sortDirection.asc': 'сначала старые',
  'history.sortDirection.desc': 'сначала новые',

  // Detail
  'detail.backToHistory': 'К истории',
  'detail.signer': 'Подписант',
  'detail.field.name': 'Имя',
  'detail.field.email': 'Email',
  'detail.field.phone': 'Телефон',
  'detail.field.dob': 'Дата рождения',
  'detail.field.address': 'Адрес',
  'detail.section.shareLink': 'Поделиться ссылкой',
  'detail.section.signedPdf': 'Подписанный PDF',
  'detail.section.sendByEmail': 'Отправить PDF на почту',
  'detail.action.toMyChat': 'Мне в чат',
  'detail.action.toMyChatSent': 'Отправлено',
  'detail.action.downloadPdf': 'Скачать PDF',
  'detail.action.shareTelegram': 'Поделиться в Telegram',
  'detail.action.sendEmail': 'Отправить',
  'detail.email.placeholder': 'получатель@example.com',
  'detail.email.success': 'Отправлено на',
  'detail.email.failed': 'Не удалось отправить на',
  'detail.notFound': 'Релиз не найден',

  // Status badges
  'status.signed': 'Подписан',
  'status.pending': 'Ожидает',

  // Sign form (recipient)
  'sign.role.banner': 'ВЫ ПОДПИСЫВАЕТЕ КАК',
  'sign.step.info': 'Ваши данные',
  'sign.step.review': 'Условия и подпись',
  'sign.step.done': 'Готово',
  'sign.intro.model': 'Заполните свои данные для оформления Model Release.',
  'sign.intro.contributor': 'Заполните свои данные для оформления Contributor Release.',
  'sign.field.fullName': 'Полное юридическое имя',
  'sign.field.dob': 'Дата рождения',
  'sign.field.phone': 'Телефон',
  'sign.field.email': 'Email',
  'sign.field.address': 'Адрес проживания',
  'sign.placeholder.fullName': 'Иванова Анна Сергеевна',
  'sign.placeholder.phone': '+7 (___) ___-__-__',
  'sign.placeholder.email': 'anna@example.com',
  'sign.placeholder.address': 'Город, улица, дом, квартира, индекс',
  'sign.next': 'Продолжить',
  'sign.summary.title': 'Краткие условия',
  'sign.summary.fullText': 'Полный текст — на следующей странице. Подписывая, вы подтверждаете всё перечисленное:',
  'sign.signHere': 'Подпишите здесь',
  'sign.signHere.hint': 'Используйте палец или мышь для подписи выше.',
  'sign.clear': 'Очистить подпись',
  'sign.agreement': 'Я прочитал(а) условия и даю своё полное согласие.',
  'sign.complete': 'Подписать и завершить',
  'sign.signing': 'Отправляем…',
  'sign.overlay.title': 'Отправляем релиз…',
  'sign.overlay.body': 'Пожалуйста, не закрывайте эту вкладку. Мы создаём PDF и отправляем его фотографу.',
  'sign.overlay.timing': 'Обычно это занимает 5–10 секунд.',
  'sign.success.title': 'Релиз подписан',
  'sign.success.toPhotographer': 'Отправлено фотографу',
  'sign.success.saved': 'Сохранено на сервере',
  'sign.success.error': 'Ошибка отправки',
  'sign.success.sending': 'Отправляем фотографу…',
  'sign.downloadPdf': 'Скачать PDF',
  'sign.alreadySigned': 'Этот релиз уже подписан.',
  'sign.linkNotFound.title': 'Ссылка не найдена',
  'sign.linkNotFound.body': 'Эта ссылка для подписания недействительна или истекла. Попросите фотографа выдать новую.',
  'sign.lang.switch': 'Язык',

  // Date helpers
  'date.today': 'сегодня',
  'date.yesterday': 'вчера',
  'date.daysAgo': '{n} дн. назад',
};

export const dict = { en, ru };
export type DictKey = keyof typeof en;
